import { ExtendedQuestionnaireBlock } from '../components/compliance/ExtendedQuestionnaire';
import { NIS2_FULL_CATEGORIES_5_12 } from './nis2FullQuestionnairesExtended';

// NIS2 Full Self-Assessment Questionnaire - Complete 135 questions across 12 categories
// Based on MASTER PACKAGE V2 requirements

export const NIS2_FULL_COMPLETE_BLOCKS: ExtendedQuestionnaireBlock[] = [
  // Category 1: Governance & Accountability (12 questions)
  {
    id: 'nis2-governance-accountability',
    name_en: 'Governance & Accountability',
    name_es: 'Gobernanza y Responsabilidad',
    name_ru: 'Управление и подотчетность',
    questions: [
      {
        id: 'NIS2_GOV_01',
        blockId: 'nis2-governance-accountability',
        text_en: 'Is a cybersecurity governance framework approved by top management?',
        text_es: '¿Existe un marco de gobernanza de ciberseguridad aprobado por la alta dirección?',
        text_ru: 'Утверждена ли политика управления кибербезопасностью руководством?',
        weight: 3,
      },
      {
        id: 'NIS2_GOV_02',
        blockId: 'nis2-governance-accountability',
        text_en: 'Are cybersecurity roles and responsibilities clearly defined?',
        text_es: '¿Están claramente definidas las funciones y responsabilidades de ciberseguridad?',
        text_ru: 'Чётко ли определены роли и ответственность за кибербезопасность?',
        weight: 3,
      },
      {
        id: 'NIS2_GOV_03',
        blockId: 'nis2-governance-accountability',
        text_en: 'Is a CISO or equivalent formally appointed?',
        text_es: '¿Se ha designado formalmente un CISO o equivalente?',
        text_ru: 'Формально ли назначен CISO или эквивалентная должность?',
        weight: 4,
      },
      {
        id: 'NIS2_GOV_04',
        blockId: 'nis2-governance-accountability',
        text_en: 'Is cybersecurity represented at board-level reviews?',
        text_es: '¿La ciberseguridad está representada en las revisiones a nivel de junta?',
        text_ru: 'Представлена ли кибербезопасность на заседаниях совета директоров?',
        weight: 5,
      },
      {
        id: 'NIS2_GOV_05',
        blockId: 'nis2-governance-accountability',
        text_en: 'Is digital operational resilience part of strategic planning?',
        text_es: '¿La resiliencia operativa digital es parte de la planificación estratégica?',
        text_ru: 'Включена ли цифровая операционная устойчивость в стратегическое планирование?',
        weight: 4,
      },
      {
        id: 'NIS2_GOV_06',
        blockId: 'nis2-governance-accountability',
        text_en: 'Do risk dashboards reach senior management monthly?',
        text_es: '¿Los tableros de riesgo llegan a la alta dirección mensualmente?',
        text_ru: 'Предоставляются ли дашборды рисков высшему руководству ежемесячно?',
        weight: 3,
      },
      {
        id: 'NIS2_GOV_07',
        blockId: 'nis2-governance-accountability',
        text_en: 'Are cybersecurity KPIs tracked and reported?',
        text_es: '¿Se rastrean y reportan los KPI de ciberseguridad?',
        text_ru: 'Отслеживаются и сообщаются ли KPI кибербезопасности?',
        weight: 2,
      },
      {
        id: 'NIS2_GOV_08',
        blockId: 'nis2-governance-accountability',
        text_en: 'Is there a budget for cybersecurity improvements?',
        text_es: '¿Existe un presupuesto para mejoras de ciberseguridad?',
        text_ru: 'Есть ли бюджет на улучшение кибербезопасности?',
        weight: 3,
      },
      {
        id: 'NIS2_GOV_09',
        blockId: 'nis2-governance-accountability',
        text_en: 'Is a cyber program reviewed annually?',
        text_es: '¿Se revisa un programa de ciberseguridad anualmente?',
        text_ru: 'Пересматривается ли программа кибербезопасности ежегодно?',
        weight: 3,
      },
      {
        id: 'NIS2_GOV_10',
        blockId: 'nis2-governance-accountability',
        text_en: 'Does the organization perform maturity assessments?',
        text_es: '¿La organización realiza evaluaciones de madurez?',
        text_ru: 'Проводит ли организация оценки зрелости?',
        weight: 2,
      },
      {
        id: 'NIS2_GOV_11',
        blockId: 'nis2-governance-accountability',
        text_en: 'Are legal/regulatory requirements tracked continuously?',
        text_es: '¿Los requisitos legales/regulatorios se rastrean continuamente?',
        text_ru: 'Отслеживаются ли правовые/нормативные требования непрерывно?',
        weight: 3,
      },
      {
        id: 'NIS2_GOV_12',
        blockId: 'nis2-governance-accountability',
        text_en: 'Are internal security audits conducted periodically?',
        text_es: '¿Se realizan auditorías internas de seguridad periódicamente?',
        text_ru: 'Проводятся ли периодически внутренние аудиты безопасности?',
        weight: 3,
      },
    ],
  },
  // Category 2: Policies & Procedures (10 questions)
  {
    id: 'nis2-policies-procedures',
    name_en: 'Policies & Procedures',
    name_es: 'Políticas y Procedimientos',
    name_ru: 'Политики и процедуры',
    questions: [
      {
        id: 'NIS2_POL_01',
        blockId: 'nis2-policies-procedures',
        text_en: 'Do you maintain approved cybersecurity policies?',
        text_es: '¿Mantiene políticas de ciberseguridad aprobadas?',
        text_ru: 'Поддерживаете ли вы утвержденные политики кибербезопасности?',
        weight: 3,
      },
      {
        id: 'NIS2_POL_02',
        blockId: 'nis2-policies-procedures',
        text_en: 'Are policies reviewed at least annually?',
        text_es: '¿Las políticas se revisan al menos anualmente?',
        text_ru: 'Пересматриваются ли политики как минимум ежегодно?',
        weight: 2,
      },
      {
        id: 'NIS2_POL_03',
        blockId: 'nis2-policies-procedures',
        text_en: 'Are AUP and RBAC documented and approved?',
        text_es: '¿El AUP y RBAC están documentados y aprobados?',
        text_ru: 'Документированы и утверждены ли AUP и RBAC?',
        weight: 3,
      },
      {
        id: 'NIS2_POL_04',
        blockId: 'nis2-policies-procedures',
        text_en: 'Are remote access policies enforced?',
        text_es: '¿Se hacen cumplir las políticas de acceso remoto?',
        text_ru: 'Обеспечивается ли соблюдение политик удаленного доступа?',
        weight: 3,
      },
      {
        id: 'NIS2_POL_05',
        blockId: 'nis2-policies-procedures',
        text_en: 'Are cloud security rules defined?',
        text_es: '¿Están definidas las reglas de seguridad en la nube?',
        text_ru: 'Определены ли правила безопасности облака?',
        weight: 3,
      },
      {
        id: 'NIS2_POL_06',
        blockId: 'nis2-policies-procedures',
        text_en: 'Is data classification documented and applied?',
        text_es: '¿La clasificación de datos está documentada y aplicada?',
        text_ru: 'Документирована и применяется ли классификация данных?',
        weight: 4,
      },
      {
        id: 'NIS2_POL_07',
        blockId: 'nis2-policies-procedures',
        text_en: 'Is encryption formally required for critical assets?',
        text_es: '¿El cifrado está formalmente requerido para activos críticos?',
        text_ru: 'Требуется ли формально шифрование для критических активов?',
        weight: 4,
      },
      {
        id: 'NIS2_POL_08',
        blockId: 'nis2-policies-procedures',
        text_en: 'Are incident reporting rules documented?',
        text_es: '¿Las reglas de reporte de incidentes están documentadas?',
        text_ru: 'Документированы ли правила сообщения об инцидентах?',
        weight: 3,
      },
      {
        id: 'NIS2_POL_09',
        blockId: 'nis2-policies-procedures',
        text_en: 'Are supplier governance requirements documented?',
        text_es: '¿Los requisitos de gobernanza de proveedores están documentados?',
        text_ru: 'Документированы ли требования по управлению поставщиками?',
        weight: 4,
      },
      {
        id: 'NIS2_POL_10',
        blockId: 'nis2-policies-procedures',
        text_en: 'Is user provisioning & offboarding documented?',
        text_es: '¿El aprovisionamiento y desvinculación de usuarios están documentados?',
        text_ru: 'Документированы ли процедуры предоставления доступа пользователям и их отзыва?',
        weight: 3,
      },
    ],
  },
  // Category 3: Risk Management (13 questions)
  {
    id: 'nis2-risk-management-complete',
    name_en: 'Risk Management',
    name_es: 'Gestión de Riesgos',
    name_ru: 'Управление рисками',
    questions: [
      {
        id: 'NIS2_RISK_01',
        blockId: 'nis2-risk-management-complete',
        text_en: 'Is the organization maintaining a full asset inventory?',
        text_es: '¿La organización mantiene un inventario completo de activos?',
        text_ru: 'Ведет ли организация полный реестр активов?',
        weight: 5,
      },
      {
        id: 'NIS2_RISK_02',
        blockId: 'nis2-risk-management-complete',
        text_en: 'Are assets classified by criticality?',
        text_es: '¿Los activos están clasificados por criticidad?',
        text_ru: 'Классифицируются ли активы по критичности?',
        weight: 5,
      },
      {
        id: 'NIS2_RISK_03',
        blockId: 'nis2-risk-management-complete',
        text_en: 'Are risks assessed at least annually?',
        text_es: '¿Los riesgos se evalúan al menos anualmente?',
        text_ru: 'Оцениваются ли риски как минимум ежегодно?',
        weight: 4,
      },
      {
        id: 'NIS2_RISK_04',
        blockId: 'nis2-risk-management-complete',
        text_en: 'Do you identify new risks after major changes?',
        text_es: '¿Identifica nuevos riesgos después de cambios importantes?',
        text_ru: 'Выявляются ли новые риски после значительных изменений?',
        weight: 3,
      },
      {
        id: 'NIS2_RISK_05',
        blockId: 'nis2-risk-management-complete',
        text_en: 'Are cyber risk scenarios documented?',
        text_es: '¿Los escenarios de riesgo cibernético están documentados?',
        text_ru: 'Документированы ли сценарии киберрисков?',
        weight: 3,
      },
      {
        id: 'NIS2_RISK_06',
        blockId: 'nis2-risk-management-complete',
        text_en: 'Do KRIs exist and monitored monthly?',
        text_es: '¿Existen KRI y se monitorean mensualmente?',
        text_ru: 'Существуют ли KRI и отслеживаются ли они ежемесячно?',
        weight: 3,
      },
      {
        id: 'NIS2_RISK_07',
        blockId: 'nis2-risk-management-complete',
        text_en: 'Do you track residual risk after mitigation?',
        text_es: '¿Rastrea el riesgo residual después de la mitigación?',
        text_ru: 'Отслеживаете ли вы остаточный риск после мер по снижению?',
        weight: 3,
      },
      {
        id: 'NIS2_RISK_08',
        blockId: 'nis2-risk-management-complete',
        text_en: 'Is penetration testing performed annually?',
        text_es: '¿Se realizan pruebas de penetración anualmente?',
        text_ru: 'Проводятся ли тесты на проникновение ежегодно?',
        weight: 4,
      },
      {
        id: 'NIS2_RISK_09',
        blockId: 'nis2-risk-management-complete',
        text_en: 'Are vulnerability scans performed monthly?',
        text_es: '¿Se realizan escaneos de vulnerabilidades mensualmente?',
        text_ru: 'Проводятся ли сканирования уязвимостей ежемесячно?',
        weight: 4,
      },
      {
        id: 'NIS2_RISK_10',
        blockId: 'nis2-risk-management-complete',
        text_en: 'Is patch compliance tracked?',
        text_es: '¿Se rastrea el cumplimiento de parches?',
        text_ru: 'Отслеживается ли соответствие требованиям по установке обновлений?',
        weight: 4,
      },
      {
        id: 'NIS2_RISK_11',
        blockId: 'nis2-risk-management-complete',
        text_en: 'Are backups aligned with RTO/RPO?',
        text_es: '¿Los respaldos están alineados con RTO/RPO?',
        text_ru: 'Соответствуют ли резервные копии RTO/RPO?',
        weight: 4,
      },
      {
        id: 'NIS2_RISK_12',
        blockId: 'nis2-risk-management-complete',
        text_en: 'Are cyber insurance requirements considered?',
        text_es: '¿Se consideran los requisitos de seguro cibernético?',
        text_ru: 'Учитываются ли требования киберстрахования?',
        weight: 2,
      },
      {
        id: 'NIS2_RISK_13',
        blockId: 'nis2-risk-management-complete',
        text_en: 'Do third-party assessments influence risk scoring?',
        text_es: '¿Las evaluaciones de terceros influyen en la puntuación de riesgo?',
        text_ru: 'Влияют ли оценки третьих сторон на оценку рисков?',
        weight: 5,
      },
    ],
  },
  // Category 4: Business Continuity & DRP (12 questions)
  {
    id: 'nis2-business-continuity-drp',
    name_en: 'Business Continuity & DRP',
    name_es: 'Continuidad del Negocio y Plan de Recuperación ante Desastres',
    name_ru: 'Непрерывность бизнеса и план восстановления после сбоев',
    questions: [
      {
        id: 'NIS2_BC_01',
        blockId: 'nis2-business-continuity-drp',
        text_en: 'Do you maintain a tested Business Continuity Plan?',
        text_es: '¿Mantiene un Plan de Continuidad del Negocio probado?',
        text_ru: 'Существует ли протестированный план непрерывности бизнеса?',
        weight: 5,
      },
      {
        id: 'NIS2_BC_02',
        blockId: 'nis2-business-continuity-drp',
        text_en: 'Do you conduct DR exercises?',
        text_es: '¿Realiza ejercicios de recuperación ante desastres?',
        text_ru: 'Проводятся ли учения по восстановлению после сбоев?',
        weight: 4,
      },
      {
        id: 'NIS2_BC_03',
        blockId: 'nis2-business-continuity-drp',
        text_en: 'Are backups geographically separated?',
        text_es: '¿Los respaldos están geográficamente separados?',
        text_ru: 'Размещаются ли резервные копии в разных географических локациях?',
        weight: 4,
      },
      {
        id: 'NIS2_BC_04',
        blockId: 'nis2-business-continuity-drp',
        text_en: 'Are RTO and RPO defined for critical systems?',
        text_es: '¿RTO y RPO están definidos para sistemas críticos?',
        text_ru: 'Определены ли RTO и RPO для критических систем?',
        weight: 5,
      },
      {
        id: 'NIS2_BC_05',
        blockId: 'nis2-business-continuity-drp',
        text_en: 'Is there a process for activating DR plans?',
        text_es: '¿Existe un proceso para activar planes de recuperación ante desastres?',
        text_ru: 'Существует ли процесс активации планов восстановления после сбоев?',
        weight: 4,
      },
      {
        id: 'NIS2_BC_06',
        blockId: 'nis2-business-continuity-drp',
        text_en: 'Are alternative processing sites identified?',
        text_es: '¿Se identifican sitios de procesamiento alternativos?',
        text_ru: 'Выявлены ли альтернативные площадки обработки?',
        weight: 4,
      },
      {
        id: 'NIS2_BC_07',
        blockId: 'nis2-business-continuity-drp',
        text_en: 'Are BC/DR plans reviewed and updated regularly?',
        text_es: '¿Los planes BC/DR se revisan y actualizan regularmente?',
        text_ru: 'Пересматриваются и обновляются ли планы BC/DR регулярно?',
        weight: 3,
      },
      {
        id: 'NIS2_BC_08',
        blockId: 'nis2-business-continuity-drp',
        text_en: 'Is there coordination with suppliers for BC?',
        text_es: '¿Existe coordinación con proveedores para continuidad del negocio?',
        text_ru: 'Существует ли координация с поставщиками по непрерывности бизнеса?',
        weight: 3,
      },
      {
        id: 'NIS2_BC_09',
        blockId: 'nis2-business-continuity-drp',
        text_en: 'Are BC exercises conducted at least annually?',
        text_es: '¿Se realizan ejercicios de continuidad del negocio al menos anualmente?',
        text_ru: 'Проводятся ли учения по непрерывности бизнеса как минимум ежегодно?',
        weight: 4,
      },
      {
        id: 'NIS2_BC_10',
        blockId: 'nis2-business-continuity-drp',
        text_en: 'Are critical dependencies mapped and monitored?',
        text_es: '¿Las dependencias críticas están mapeadas y monitoreadas?',
        text_ru: 'Выявлены и контролируются ли критические зависимости?',
        weight: 4,
      },
      {
        id: 'NIS2_BC_11',
        blockId: 'nis2-business-continuity-drp',
        text_en: 'Is there redundancy for critical systems?',
        text_es: '¿Existe redundancia para sistemas críticos?',
        text_ru: 'Существует ли избыточность для критических систем?',
        weight: 5,
      },
      {
        id: 'NIS2_BC_12',
        blockId: 'nis2-business-continuity-drp',
        text_en: 'Are business impact analyses conducted?',
        text_es: '¿Se realizan análisis de impacto en el negocio?',
        text_ru: 'Проводятся ли анализы влияния на бизнес?',
        weight: 4,
      },
    ],
  },
  // Categories 5-12: Supply Chain, Network Security, Access Control, Incident Response, Monitoring, Cryptography, Asset Management, HR Security
  ...NIS2_FULL_CATEGORIES_5_12,
];

// NIS2 DOCUMENTS, PROCESSES, ROLES (Extended)
const NIS2_DOCUMENTS_BLOCKS: ExtendedQuestionnaireBlock[] = [
  { id: 'nis2-doc-rm', name_en: 'Risk Management Docs', name_es: 'Docs Gestión Riesgos', name_ru: 'Документы по рискам',
    questions: [
      { id: 'nis2-doc-1', blockId: 'nis2-doc-rm', text_en: 'Risk management policy documented?', text_es: '¿Política de gestión de riesgos documentada?', text_ru: 'Политика управления рисками документирована?' },
      { id: 'nis2-doc-2', blockId: 'nis2-doc-rm', text_en: 'Incident response procedures documented?', text_es: '¿Procedimientos de respuesta a incidentes documentados?', text_ru: 'Процедуры реагирования документированы?' },
    ] },
];
const NIS2_PROCESSES_BLOCKS: ExtendedQuestionnaireBlock[] = [
  { id: 'nis2-proc-rm', name_en: 'Risk Management Process', name_es: 'Proceso Gestión Riesgos', name_ru: 'Процесс управления рисками',
    questions: [
      { id: 'nis2-proc-1', blockId: 'nis2-proc-rm', text_en: 'Cybersecurity risk assessment process?', text_es: '¿Proceso de evaluación de riesgos de ciberseguridad?', text_ru: 'Процесс оценки киберрисков?' },
      { id: 'nis2-proc-2', blockId: 'nis2-proc-rm', text_en: 'Incident detection and reporting process?', text_es: '¿Proceso de detección y reporte de incidentes?', text_ru: 'Процесс выявления и сообщения об инцидентах?' },
    ] },
];
const NIS2_ROLES_BLOCKS: ExtendedQuestionnaireBlock[] = [
  { id: 'nis2-roles', name_en: 'Key Roles', name_es: 'Roles Clave', name_ru: 'Ключевые роли',
    questions: [
      { id: 'nis2-role-1', blockId: 'nis2-roles', text_en: 'Cybersecurity lead/manager assigned?', text_es: '¿Responsable de ciberseguridad asignado?', text_ru: 'Назначен ответственный за кибербезопасность?' },
      { id: 'nis2-role-2', blockId: 'nis2-roles', text_en: 'Incident response coordinator assigned?', text_es: '¿Coordinador de respuesta a incidentes asignado?', text_ru: 'Назначен координатор по инцидентам?' },
    ] },
];

export const NIS2_FULL_QUESTIONNAIRES = {
  SELF_ASSESSMENT: NIS2_FULL_COMPLETE_BLOCKS,
  DOCUMENTS: NIS2_DOCUMENTS_BLOCKS,
  PROCESSES: NIS2_PROCESSES_BLOCKS,
  ROLES: NIS2_ROLES_BLOCKS,
};

